const _ = require('lodash')

const orders = require('./modules/orders')
const items = require('./modules/items')
const supplier = require('./modules/supplier')
const supplierRejectionRules = require('./modules/supplierRejectionRules')

const SCHEMAS = {
  orders,
  items,
  supplier,
  supplierRejectionRules
}

const _deepPick = (payload, json) => {
  if (_.isArray(payload)) {
    return payload.map(item => _deepPick(item, json))
  }

  const object = _.pick(payload, _.keys(json))
  return object
}

export const stripPayload = (payload, schema) => {
  return _deepPick(payload, SCHEMAS[schema])
}



// WEBPACK FOOTER //
// ./src/schemas/index.js